import { Component, OnInit } from '@angular/core';
import { environment } from '@ao/environments/environment';

@Component({
  selector: 'app-footer',
  standalone: true,
  imports: [],
  templateUrl: './footer.component.html',
  styleUrl: './footer.component.scss',
})
export class FooterComponent implements OnInit {
  year: number | undefined;

  ngOnInit() {
    this.year = new Date().getFullYear();
  }

  protected readonly environment = environment;
}
